var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 16,0C 7.164,0,0,7.164,0,16s 7.164,16, 16,16s 16-7.164, 16-16C 32,7.162, 24.836,0, 16,0z M 17.248,20.326 c-1.17-0.090-1.66-0.67-2.576-1.228c-0.504,2.644-1.12,5.18-2.944,6.502C 11.164,21.606, 12.554,18.606, 13.2,15.42 C 12.1,13.566, 13.332,9.84, 15.652,10.758c 2.854,1.13-2.474,6.886, 1.104,7.604c 3.734,0.752, 5.26-6.48, 2.944-8.832 c-3.348-3.396-9.74-0.078-8.954,4.784c 0.192,1.188, 1.418,1.548, 0.49,3.19C 9.094,17.030, 8.454,15.34, 8.536,13.088 c 0.132-3.686, 3.312-6.266, 6.502-6.624c 4.034-0.452, 7.818,1.48, 8.342,5.274C 23.97,16.020, 21.56,20.66, 17.248,20.326z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/Pinterest.2a2ce9833677d44f6bfacc55f21fa36e.svg";
export { ForwardRef as ReactComponent };